import React from "react";

//Routes
import { MainRoutes, AuthRoutes } from "./views/routes";

//Template com as rotas
import Template from "./views/Template";

//Context
import { useAuth } from "./providers/auth";

import useLocalStorage from "use-local-storage";

function App() {

  const { user } = useAuth();

  //setting the theme of app
  const [theme, setTheme] = useLocalStorage("theme", "");

  return user.token ?
    <Template>
      <MainRoutes />
    </Template> : <AuthRoutes />;
}

export default App;